/* ── EmJ Jewels — Shopify JS ── */

/* ── HAMBURGER MENU ── */
function _setMenuPosition() {
  const nav = document.getElementById('main-nav');
  const menu = document.getElementById('mobile-menu');
  if (nav && menu) {
    menu.style.top = nav.getBoundingClientRect().bottom + 'px';
  }
}

function toggleMenu() {
  const btn = document.getElementById('hamburger');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  _setMenuPosition();
  const isOpen = menu.classList.toggle('open');
  btn.classList.toggle('open', isOpen);
  btn.setAttribute('aria-expanded', String(isOpen));
  menu.setAttribute('aria-hidden', String(!isOpen));
}

function closeMenu() {
  const btn = document.getElementById('hamburger');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  btn.classList.remove('open');
  menu.classList.remove('open');
  btn.setAttribute('aria-expanded', 'false');
  menu.setAttribute('aria-hidden', 'true');
}

// Keep menu position correct on resize/scroll
window.addEventListener('resize', () => {
  const menu = document.getElementById('mobile-menu');
  if (menu && menu.classList.contains('open')) _setMenuPosition();
}, { passive: true });
document.addEventListener('click', (e) => {
  const nav = document.getElementById('main-nav');
  const menu = document.getElementById('mobile-menu');
  if (!nav || !menu) return;
  if (!nav.contains(e.target) && !menu.contains(e.target)) closeMenu();
});

/* ── NAV SCROLL EFFECT ── */
window.addEventListener('scroll', () => {
  const nav = document.getElementById('main-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

/* ── SCROLL TRACK (New Arrivals) ── */
function scrollTrack(trackId, dir) {
  const track = document.getElementById(trackId);
  if (track) track.scrollBy({ left: dir * 580, behavior: 'smooth' });
}

/* ── TOAST NOTIFICATION ── */
let _toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
}

/* ── QUICK ADD TO CART (Shopify AJAX Cart API) ── */
function quickAddToCart(variantId, btn) {
  if (!variantId) return;
  const original = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(data => {
    if (data.status) {
      showToast('Could not add item. Please try again.');
    } else {
      showToast(`"${data.product_title}" added to cart ✨`);
      updateCartCount();
    }
  })
  .catch(() => showToast('Something went wrong. Please try again.'))
  .finally(() => {
    btn.textContent = original;
    btn.disabled = false;
  });
}

/* ── UPDATE CART COUNT IN NAV ── */
function updateCartCount() {
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const badge = document.getElementById('cart-badge');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.classList.toggle('visible', cart.item_count > 0);
  })
  .catch(() => {});
}

/* ── CART QTY UPDATE ── */
function updateCartQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(res => res.json())
  .then(() => location.reload())
  .catch(() => showToast('Could not update cart. Please try again.'));
}

/* ── PRODUCT PAGE: IMAGE SWITCHER ── */
function switchImage(src, btn) {
  const main = document.getElementById('product-featured-img');
  if (main) main.src = src;
  document.querySelectorAll('.thumbnail-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
}

/* ── PRODUCT PAGE: VARIANT SELECTION ── */
document.addEventListener('DOMContentLoaded', () => {
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-options');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});
